import React, { Component, Fragment } from 'react';
import Progress from '../../components/Progress';
import CardDeck from '../../components/Voting/CardDeck';
import Results from '../../components/Voting/Results';
import VotingTitle from '../../components/Voting/Title';
import ANSWERS from '../../constants/answers';
import './styles.scss';
import Spinner from '../../components/common/Spinner';

class Voting extends Component {
  state = {
    showChangeAnswerModal: false,
    questionIdToChange: null,
    isOngoing: true,
    likes: {},
    answers: {},
    currentIndex: 0
  };

  componentWillMount() {
    this.props.getQuestionnaire();
  }

  toNextQuestionWithAnswer = answer => {
    const { questionnaire } = this.props;
    const { questions } = questionnaire;

    this.setState(
      prevState => {
        const currentIndex = prevState.currentIndex + 1;
        const questionId = questions[prevState.currentIndex].id;
        const isOngoing = questions.length > currentIndex;

        return {
          answers: {
            ...prevState.answers,
            [questionId]: answer
          },
          currentIndex,
          isOngoing
        };
      },
      () => {
        if (!this.state.isOngoing) {
          // this.saveQuestionnairesResults();
        }
      }
    );
  };

  onAgreeClick = () => {
    this.toNextQuestionWithAnswer(ANSWERS.YES);
  };

  onDisagreeClick = () => {
    this.toNextQuestionWithAnswer(ANSWERS.NO);
  };

  onToggleLike = () => {
    const { questionnaire } = this.props;
    const { questions } = questionnaire;

    this.setState(prevState => {
      const questionId = questions[prevState.currentIndex].id;
      return {
        likes: {
          ...prevState.likes,
          [questionId]: !prevState.likes[questionId]
        }
      };
    });
  };

  handleQuestionClick = id => {
    this.setState({
      showChangeAnswerModal: true,
      questionIdToChange: id
    });
  };

  saveQuestionnairesResults = () => {
    const { answers, likes, isOngoing } = this.state;
    const result = { answers, likes, isOngoing };
    this.props.saveQuestionnairesResults(result);
  };

  renderLoading = () => <Spinner />;

  renderVoting = questionnaire => {
    const { currentIndex, isOngoing, likes, answers } = this.state;
    const { questions, title } = questionnaire;
    const percentage = (100 / questions.length) * (currentIndex + 1);

    return isOngoing ? (
      <React.Fragment>
        <div className="title-container">
          <VotingTitle title={title} />
        </div>
        <CardDeck
          questions={questions}
          likes={likes}
          onAgreeClick={this.onAgreeClick}
          onDisagreeClick={this.onDisagreeClick}
          onLikeToggle={this.onToggleLike}
          currentIndex={currentIndex}
        />
        <Progress questionsNumber={questions.length} currentIndex={currentIndex} percentage={percentage} />
      </React.Fragment>
    ) : (
      <div className={'results-container fancy-scrollbar'}>
        <Results
          title={title}
          answers={answers}
          likes={likes}
          onQuestionClick={this.handleQuestionClick}
          questions={questions.map(it => ({
            id: it.id,
            text: it.text,
            invertsAnswer: it.invertsAnswer,
            answer: answers[it.id],
            isLiked: likes[it.id]
          }))}
        />
      </div>
    );
  };

  render() {
    const { questionnaire } = this.props;

    return (
      <Fragment>
        <div className="voting">
          <div className="voting-content">
            {questionnaire ? this.renderVoting(questionnaire) : this.renderLoading()}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Voting;
